import React, { useState } from "react";

import { Modal } from "reactstrap";
import { toast } from "react-toastify";

import "assets/css/home-modern.css";
import "assets/css/flow.css";

// core components
import DefaultFooter from "components/Footers/DefaultFooter.js";
import IndexNavbar from "components/Navbars/IndexNavbar";
import FlowHero from "components/Flow/FlowHero";
import FlowEmpty from "components/Flow/FlowEmpty";
import QtyStepper from "components/Flow/QtyStepper";
import SummaryBar from "components/Flow/SummaryBar";
import ProductSearch from "components/Flow/ProductSearch";
import PlanComparisonModal from "components/Membership/PlanComparisonModal";
import { APIRequest } from "utils/ApiRequest";
import { filterProducts, hasQuery } from "utils/productSearch";
import { formatINR } from "utils/format";
import { PLAN_META, planKeyFor, planMetaFor } from "utils/membershipPlans";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import heroImage from "assets/img/banner1.jpg";

const FLOW_STEPS = ["Membership", "Sponsorship", "Review & pay"];

function MembersipPage() {
  const [membershipProducts, setMembershipProducts] = React.useState(null);
  const [selectedPrds, setSelectedPrds] = useState({});
  const [totalCartPrice, setTotalCartPrice] = useState(0);
  const [modalLarge, setModalLarge] = React.useState(false);
  const [modalLive, setModalLive] = React.useState(false);
  const [query, setQuery] = useState("");

  const history = useNavigate();

  React.useEffect(() => {
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let userInfo = localStorage.getItem('user-info');
    if (userInfo != null) {
      userInfo = JSON.parse(userInfo);
      if (userInfo.session != null) {
        loadProducts(userInfo.session);
        let sPrd = localStorage.getItem('selectedPrds');
        if (sPrd != null) {
          setSelectedPrds(JSON.parse(sPrd));
        }
        let tcp = localStorage.getItem('totalCartPrice');
        setTotalCartPrice(tcp != null ? parseInt(tcp) : 0);

      } else {
        history("/login")
      }
    } else {
      history("/login")
    }

    return function cleanup() {
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  function loadProducts(token) {
    APIRequest(
      token,
      "/getProducts",
      {},
      (res) => {
        const products = res.data.productsResponses != null
          ? res.data.productsResponses["MEMBERSHIP"]
          : null;
        setMembershipProducts(products != null ? products : []);
      },
      () => {
        setMembershipProducts([]);
      }
    );
  }

  const handleStartOver = (e) => {
    localStorage.removeItem('selectedPrds');
    localStorage.removeItem('totalCartPrice');
    setTotalCartPrice(0);
    setSelectedPrds({});
  }

  const handleProductDec = (productId, price, code) => {
    if (selectedPrds.hasOwnProperty(productId) && selectedPrds[productId].qty > 0) {
      let q = selectedPrds[productId].qty;
      if (q === 1) {
        delete selectedPrds[productId];
      } else {
        selectedPrds[productId].price = price * (q - 1);
        selectedPrds[productId].qty = q - 1;
      };

      if (q > 4 && code === "MUTV") {
        let discountedPrice = price * 0.85 * (q - 1);
        selectedPrds[productId].price = discountedPrice;
      }

      if (q === 4 && code === "MUTV") {
        let discountedPrice = price * 0.95 * (q - 1);
        selectedPrds[productId].price = discountedPrice;
        toast.warn("Benifit reduced 10% to 5%, effective price for three UTSAV membership plan is: " + discountedPrice);
      }

      if (q === 3 && code === "MUTV") {
        let newPrice = price * (q - 1);
        selectedPrds[productId].price = newPrice;
        toast.warn("Benefit removed, effective price for two UTSAV membership plan is: " + newPrice);
      }

      let totalPrice = 0;
      Object.keys(selectedPrds).map((k, i) => {
        totalPrice = totalPrice + selectedPrds[k].price;
      });

      setSelectedPrds(selectedPrds);
      setTotalCartPrice(totalPrice);
      localStorage.removeItem('selectedPrds');
      localStorage.setItem('selectedPrds', JSON.stringify(selectedPrds));
      localStorage.removeItem('totalCartPrice');
      localStorage.setItem('totalCartPrice', totalPrice);
    }
  };

  const handleProductInc = (productId, price, code) => {
    if (!selectedPrds.hasOwnProperty(productId)) {
      let prdDetails = {};
      prdDetails["qty"] = 1;
      prdDetails["price"] = price;
      prdDetails["code"] = code;
      selectedPrds[productId] = prdDetails;
    } else {
      let q = selectedPrds[productId].qty;
      selectedPrds[productId].qty = q + 1;
      selectedPrds[productId].price = selectedPrds[productId].price + price;

      if (q === 2 && code === "MUTV") {
        let discountedPrice = price * 0.95 * (q + 1);
        selectedPrds[productId].price = discountedPrice;
        toast.success("5% benefit added new effective contribution for three UTSAV membership plan is: " + discountedPrice);
      }

      if (q === 3 && code === "MUTV") {
        let discountedPrice = price * 0.90 * (q + 1);
        selectedPrds[productId].price = discountedPrice;
        toast.success("10% benefit added new effective contribution for four UTSAV membership plan is: " + discountedPrice);
      }

      if (q > 3 && code === "MUTV") {
        let discountedPrice = price * 0.90 * (q + 1);
        selectedPrds[productId].price = discountedPrice;
      }

    }



    let totalPrice = 0;
    Object.keys(selectedPrds).map((k, i) => {
      totalPrice = totalPrice + selectedPrds[k].price;
    });

    setSelectedPrds(selectedPrds);
    setTotalCartPrice(totalPrice);
    localStorage.removeItem('selectedPrds');
    localStorage.setItem('selectedPrds', JSON.stringify(selectedPrds));
    localStorage.removeItem('totalCartPrice');
    localStorage.setItem('totalCartPrice', totalPrice);
  }

  const handleProceedToSponsorship = (e) => {
    if (totalCartPrice <= 0) {
      setModalLive(true);
    } else {
      history("/sponsorship");
    }
    e.preventDefault();
  }

  const handleForceProceedToSponsorship = (e) => {
    setModalLive(false);
    history("/sponsorship");
  }

  const handleModalClose = () => {
    setModalLarge(false);
  }

  const handleViewMembership = () => {
    setModalLarge(true);
  }

  const availablePlans = membershipProducts != null
    ? membershipProducts.filter((mprd) => mprd.available)
    : null;

  const visiblePlans = filterProducts(availablePlans, query);
  const isSearching = hasQuery(query);

  const memberCount = Object.keys(selectedPrds)
    .reduce((sum, key) => sum + (selectedPrds[key].qty || 0), 0);

  const priceForPlan = (planKey) => {
    const match = availablePlans != null
      ? availablePlans.find((mprd) => planKeyFor(mprd) === planKey)
      : null;
    return match != null ? match.price : PLAN_META[planKey].price;
  };

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <FlowHero
          image={heroImage}
          eyebrow={"Step 1 of " + FLOW_STEPS.length}
          title="Membership & Renewal"
          lead="Choose a tier for every member of your family. Contribution is per person, and a family of three or more gets a benefit on UTSAV."
          steps={FLOW_STEPS}
          activeStep={0}
        />
        <div className="main hm hm-flow">
          <section className="hm-fbody">
            <div className="hm-wrap">
              {availablePlans == null && (
                <div className="hm-fstate">
                  <span className="hm-spinner" aria-hidden="true"></span>
                  <p style={{ margin: 0 }}>Loading membership plans…</p>
                </div>
              )}

              {availablePlans != null && availablePlans.length === 0 && (
                <FlowEmpty
                  icon="now-ui-icons ui-1_calendar-60"
                  title="Membership has not opened yet"
                  message="Enrolment and renewal for this year's Durgotsav are not live at the moment. Please check back in a little while — we will announce it here as soon as the plans go on sale."
                >
                  <Link className="hm-btn hm-btn-primary" to="/index">
                    Back to home
                  </Link>
                  <button className="hm-btn hm-btn-outline" type="button" onClick={handleViewMembership}>
                    See what membership includes
                  </button>
                </FlowEmpty>
              )}

              {availablePlans != null && availablePlans.length > 0 && (
                <>
                <div className="hm-notice">
                  <span className="hm-notice-ico" aria-hidden="true">
                    <i className="now-ui-icons travel_info"></i>
                  </span>
                  <div className="hm-notice-body">
                    <h3>Before you choose</h3>
                    <ul>
                      <li>
                        A family of <b>three</b> or <b>four</b> members gets <b>5%</b> and <b>10%</b> benefit
                        respectively on the UTSAV plan.
                      </li>
                      <li>
                        <b>Experience exclusivity!</b> UTSAV fees are waived for up to <b>4</b> family members
                        with full sponsorships of <b>&#x20B9;15,000+</b>, and for up to <b>6</b> members with
                        full sponsorships of <b>&#x20B9;35,000+</b>.
                      </li>
                      <li>Set the <b>number of family members</b> on the plan you pick below.</li>
                    </ul>
                    <div className="hm-notice-foot">
                      <button className="hm-btn hm-btn-outline" type="button" onClick={handleViewMembership}>
                        <i className="now-ui-icons files_paper"></i> Compare all plans
                      </button>
                    </div>
                  </div>
                </div>

                <ProductSearch
                  id="membership-search"
                  value={query}
                  onChange={setQuery}
                  placeholder="Search plans by name or code…"
                  label="Search membership plans"
                  noun={availablePlans.length === 1 ? "plan" : "plans"}
                  resultCount={visiblePlans.length}
                  totalCount={availablePlans.length}
                />

                {isSearching && visiblePlans.length === 0 && (
                  <div className="hm-fstate">
                    <p style={{ margin: 0 }}>
                      No membership plan matches <b>“{query.trim()}”</b>.
                    </p>
                    <button className="hm-btn hm-btn-outline" type="button" onClick={() => setQuery("")}>
                      Clear search
                    </button>
                  </div>
                )}

                {visiblePlans.length > 0 && (
                <div className="hm-plans">
                  {visiblePlans.map((mprd) => {
                    const meta = planMetaFor(mprd);
                    const picked = selectedPrds[mprd.id];
                    const qty = picked != null ? picked.qty : 0;
                    const lineTotal = picked != null ? picked.price : 0;
                    const saving = mprd.price * qty - lineTotal;
                    return (
                      <div
                        className={
                          "hm-plan" +
                          (meta != null && meta.featured ? " hm-feat" : "") +
                          (meta == null ? " hm-plan-nofeat" : "") +
                          (qty > 0 ? " is-picked" : "")
                        }
                        key={mprd.id}
                      >
                        <div className="hm-plan-head">
                          <div className="hm-plan-name">{mprd.name}</div>
                          <div className="hm-plan-price">
                            &#x20B9;{formatINR(mprd.price)}
                            <span> / person</span>
                          </div>
                        </div>
                        {meta != null && (
                          <ul>
                            {meta.features.map((feature, i) => (
                              <li className={feature.on ? "" : "hm-off"} key={i}>
                                {feature.text}
                              </li>
                            ))}
                          </ul>
                        )}
                        <div className="hm-plan-foot">
                          <div className="hm-pick">
                            <span className="hm-pick-l">Family members</span>
                            <QtyStepper
                              qty={qty}
                              label={mprd.name}
                              onDecrease={() => handleProductDec(mprd.id, mprd.price, mprd.code)}
                              onIncrease={() => handleProductInc(mprd.id, mprd.price, mprd.code)}
                            />
                          </div>
                          {qty > 0 && (
                            <p className="hm-pick-sum">
                              <span>{qty} × &#x20B9;{formatINR(mprd.price)}</span>
                              <b>&#x20B9;{formatINR(lineTotal)}</b>
                            </p>
                          )}
                          {saving >= 1 && (
                            <span className="hm-save">You save &#x20B9;{formatINR(saving)}</span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                )}

                <SummaryBar
                  label="Membership total"
                  total={totalCartPrice}
                  note={
                    memberCount > 0
                      ? memberCount + (memberCount === 1 ? " member selected" : " members selected")
                      : "No member added yet — sponsorship is still optional"
                  }
                >
                  <button
                    className="hm-btn hm-btn-outline hm-btn-quiet"
                    type="button"
                    onClick={handleStartOver}
                    disabled={memberCount === 0 && totalCartPrice === 0}
                  >
                    Clear selection
                  </button>
                  <button className="hm-btn hm-btn-primary" type="button" onClick={handleProceedToSponsorship}>
                    Proceed to sponsorship <i className="now-ui-icons arrows-1_minimal-right"></i>
                  </button>
                </SummaryBar>
                </>
              )}
            </div>
          </section>
        </div>
        <DefaultFooter />
      </div>

      <PlanComparisonModal
        isOpen={modalLarge}
        onClose={handleModalClose}
        priceForPlan={priceForPlan}
      />

      <Modal
        isOpen={modalLive}
        centered
        contentClassName="hm-modal"
        toggle={() => setModalLive(false)}
      >
        <div className="hm-modal-head">
          <h5 className="hm-modal-title">Proceed without a membership?</h5>
          <button
            aria-label="Close"
            className="hm-modal-x"
            type="button"
            onClick={() => setModalLive(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="hm-modal-body">
          <p>
            <b>You haven't added your family member count.</b> Without a membership you will miss the
            members' exclusive benefits. Continue to sponsorship anyway?
          </p>
        </div>
        <div className="hm-modal-foot">
          <button className="hm-btn hm-btn-outline" type="button" onClick={() => setModalLive(false)}>
            No, stay here
          </button>
          <button
            className="hm-btn hm-btn-primary"
            type="button"
            onClick={(e) => handleForceProceedToSponsorship(e)}
          >
            Yes, proceed
          </button>
        </div>
      </Modal>
    </>
  );
}

export default MembersipPage;
